<div class="stikytop"></div>
<div class="legalParallax">
    <div class="container" style="text-align: center;">
        <div class="row" style="height: 100px;"></div>
        <h1 class="mt-5" style="color: #fff;">Legal</h1>
    </div>
</div>
<div class="container">
    <div class="row mt-5 mb-5">
        <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item" role="presentation">
                <button class="nav-link active" id="home-tab" data-bs-toggle="tab" data-bs-target="#impressum"
                    type="button" role="tab" aria-controls="home" aria-selected="true">Impressum</button>
            </li>
            <li class="nav-item" role="presentation">
                <button class="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#privacyPolicy"
                    type="button" role="tab" aria-controls="profile" aria-selected="false">Privacy Policy</button>
            </li>
        </ul>
        <div class="tab-content" id="myTabContent">
            <div class="tab-pane fade show active" id="impressum" role="tabpanel" aria-labelledby="home-tab">
                <div class="row">
                    <div class="col">
                        <br><br>
                        <h6>The Ducatus Property website is owned by:</h6>
                        <h6>Centurion Marketing Inc.</h6>
                        <h6>Torre Advanced Building 1/F</h6>
                        <h6>Ricardo Arias St., Republic of Panama</h6>
                        <h6><a href="https://www.ducatus.com" target="_blank">www.ducatus.com</a></h6>
                        <br>
                        <h6>Silke Leistner, Head of International Relations & Sales</h6>
                        <br>
                        <h6>
                            For any questions you may have regarding our Company, send us an email via <a
                                href="mailto:support@centuriongm.com"> support@centuriongm.com.</a>
                            <br>
                            <br>
                            Proprietary Rights
                            <br>
                            <br>
                            The materials on this website, including the information available on or through this
                            website
                            (the
                            “Contents”) are protected by copyright, trademark and other forms of proprietary rights. All
                            rights,
                            title and interest in the Contents are owned by, licensed to or controlled by the Company.
                            <br>
                            <br>
                            Contents
                            <br>
                            <br>
                            Except as otherwise provided, no part of the Contents of this website shall be reproduced,
                            republished,
                            uploaded, posted, transmitted or otherwise distributed in any way, without the prior written
                            permission
                            of the Company.
                            <br>
                            <br>
                            Modification of any of the Contents or use of the Contents for any other purpose will be a
                            violation of
                            the Company’s copyright and other intellectual property rights. Graphics and images on this
                            website are
                            protected by copyright and may not be reproduced or appropriated in any manner without the
                            written
                            permission of the respective copyright owners.
                            <br>
                            <br>
                            The design and layout of this website is protected by intellectual property and other laws
                            and
                            may not
                            be copied or reproduced in whole or in part. No logo, graphic, sound, image, text or any
                            other
                            content
                            from this website may be copied, reproduced or transmitted unless expressly permitted in
                            writing
                            by the
                            Company.
                            <br>
                            <br>
                        </h6>
                    </div>
                </div>
            </div>
            <div class="tab-pane fade" id="privacyPolicy" role="tabpanel" aria-labelledby="profile-tab">
                <h6>
                    <br>
                    <br>
                    Ducatus Property Privacy Policy
                    <br>
                    <br>
                    <b style="color: #012b43;">1.Introduction</b>
                    <br>
                    <br>
                    Centurion Marketing Inc. operates property.ducatus.com (the “Site”). This Privacy Policy is designed
                    to inform you of our policies regarding the collection, use and disclosure of Personal Data we
                    receive from you, as well as to assist you in making an informed decision before providing us with
                    any of your Personal Information.
                    <br>
                    <br>
                    In this Privacy Policy, “we”, “us”, “our” shall mean Centurion Marketing Inc., having its registered
                    office in the Republic of Panama, in its capacity as Recipient and Processor under GDPR.
                    <br>
                    <br>
                    If you, at any time, have any queries on this Privacy Policy or any other queries in relation to how
                    we may manage, process and protect your personal data, please do not hesitate to contact our Data
                    Protection Officer.
                    <br>
                    <br>
                    Email address: <a href="mailto:support@centuriongm.com">support@centuriongm.com</a>
                    (Attention to: Data Protection Officer)
                    <br>
                    <br>
                    By using the Site and/or our other services and/or products, you express your agreement with this
                    Policy and the conditions of processing your Personal Data contained herein; if you do not agree
                    with these conditions, you should not use the Site and/or our other services and/or products.
                    <br>
                    <br>
                    <b style="color: #012b43;">2.Data we collect</b>
                    <br>
                    <br>
                    Personal Data: While using the Site, and/or our services and/or our products we may ask you to
                    provide
                    us Personal Data that can be used to contact or identify you. “Personal Data” is defined to mean
                    data,
                    whether true or not, about an individual who can be identified from that data, or from that data and
                    other information to which an organisation has or is likely to have access provided that to the
                    extent
                    you reside in, or are otherwise subject to the personal data laws of, a jurisdiction the relevant
                    laws
                    or other applicable rules of which provide for a different definition of personal data, the
                    definition
                    of “Personal Data” hereunder shall be construed to also encompass any other types of data that are
                    included in such different definition. The Personal Data that we may collect from you includes, but
                    is
                    not limited to, your salutation, name, company, designation, industry, gender, country of residence,
                    contact number and one or more email addresses.
                    <br>
                    <br>
                    Log Data:
                    Like many site operators, we automatically collect information that your browser sends whenever you
                    visit our Site (“Log Data”). This Log Data includes information such as your computer’s Internet
                    Protocol (“IP”) address, browser type, browser version, the pages of the Site that you visit, the
                    time
                    and date of your visit, the time spent on those pages and other statistics. We may use this
                    information
                    to monitor server errors, server administration or to monitor visitor behaviour on our Site. It is
                    from
                    a technical perspective not possible for the single user to disable the collection of the
                    aforementioned
                    data, so in case the user disagrees with this data processing, the user must not use the Site.
                    <br>
                    <br>
                    Other Information: To enable us to deliver our services and products to you, we use third party
                    services
                    to integrate with our Site. Third party services typically are applications and/or software that
                    integrate with our services. The provider of a third-party service may share certain information
                    with
                    us. For example, when using a payment service/application on our Site, we may receive your username
                    and
                    email address, along with additional information that the third-party application has elected to
                    make
                    available to us to facilitate the integration. You should check the privacy settings and notices in
                    these third-party services/applications to understand what data may be disclosed to us. We are
                    authorized to connect and access information made available to us in accordance with our agreement
                    with
                    the third-party provider. We do not, however, receive or store passwords for any of these
                    third-party
                    services when connecting them to our Site.
                    <br>
                    <br>
                    <b style="color: #012b43;">3.Purposes for Collection, Use & Disclosure of Personal Data</b>
                    <br>
                    <br>
                    The Personal Data set out in Section 2 above which we collect from you may be collected, processed,
                    used
                    and/or disclosed to the recipients mentioned below for the following purposes operate our business
                    maintain and improve your access and/or use of the Site providing you with information and/or
                    updates on
                    products, services and promotions offered by us and selected third parties, including personalized
                    content and information such as online advertisements or other forms of marketing to you
                    facilitating,
                    processing, dealing with, administering, managing and/or maintaining your relationship with us;
                    <br>
                    <br>
                    carrying out your instructions or responding to any enquiry given by (or purported to be given by)
                    you
                    or on your behalf and to meet with regulatory requirements imposed by our regulators and the
                    regulators
                    of the countries we operate in (collectively, the “Purposes”).
                    <br>
                    <br>
                    We process your Personal Data based on your consent according to Article 6 paragraph 1 (a) GDPR, in
                    the
                    event of a contract being concluded, according to Article 6 paragraph 1 (b) of the GDPR and for the
                    purposes of our legitimate interests according to Article 6 paragraph 1 (f) GDPR.
                    <br>
                    <br>
                    In order to conduct our business operations more smoothly, we may also be disclosing the personal
                    data
                    you have provided to us to our third party service providers, agents and/or our affiliates or
                    related
                    corporations (as mentioned in Section 1 above) (some of which may be situated outside of the country
                    in
                    which you live or of which you are a passport holder), for one or more of the above-stated Purposes.
                    The
                    level of data protection in another country may not be equivalent to that in your country. However,
                    we
                    only transfer your personal data to countries where the Commission of the European Union has decided
                    that they have an adequate level of data protection or we take measures to ensure that the
                    recipients
                    provide an adequate level of data protection. We do this for example by entering into appropriate
                    data
                    transfer agreements based on standard contractual clauses. Such third-party service providers,
                    agents
                    and/or affiliates or related corporations would be processing your Personal Data on our behalf for
                    one
                    or more of the above-stated Purposes. Therefore, we, in our capacity as controller have entered into
                    appropriate data transfer agreements to ensure the processing by the above-mentioned categories of
                    processors in accordance with GDPR.
                    <br>
                    <br>
                    Currently, we disclose the personal data you have provided us only to our Ducatus Tech Team who
                    processes information on our behalf. As our business grows and evolves, the processors we engage may
                    also change. We will endeavor to provide you with notice of any new processors to the extent
                    required
                    under the agreement, along with posting such updates here. Please check back frequently for updates.
                    <br>
                    <br>
                    <b style="color: #012b43;">4.Specific issues for the disclosure of personal data to third party</b>
                    <br>
                    <br>
                    We respect the confidentiality of the personal data you have provided to us. In this regard, apart
                    from
                    the Purposes set out above, we will not disclose any of your personal data to any third parties
                    without
                    first obtaining your express consent permitting us to do so. However, please note that we may
                    disclose
                    your personal data to third parties, including to parties and third-parties located outside your
                    jurisdiction, without first obtaining your consent in certain situations, including, without
                    limitation,
                    the following cases in which the disclosure is required based on the applicable laws and/or
                    regulations
                    cases in which the purpose of such disclosure is clearly in your interests, and if consent cannot be
                    obtained in a timely way cases in which the disclosure is necessary to respond to an emergency that
                    threatens the life, health or safety of yourself or another individual cases in which there are
                    reasonable grounds to that the health or safety of yourself or another individual will be seriously
                    affected and consent for the disclosure of the data cannot be obtained in a timely way, provided
                    that we
                    shall, as soon as may be practicable, notify you of the disclosure and the purposes of the
                    disclosure;
                    <br>
                    <br>
                    cases in which the disclosure is necessary for any investigation or proceedings;
                    <br>
                    <br>
                    cases in which the personal data is disclosed to any officer of a prescribed law enforcement agency,
                    upon production of written authorization signed by the head or director of that law enforcement
                    agency
                    or a person of a similar rank, certifying that the personal data is necessary for the purposes of
                    the
                    functions or duties of the officer;
                    <br>
                    <br>
                    cases in which the disclosure is to a public agency and such disclosure is necessary in the public
                    interest or cases where such provision is required for your use of any of our services or products
                    or
                    the performance of any agreement or contract with us.
                    <br>
                    <br>
                    Kindly note that the instances listed above are not intended to be exhaustive and would include
                    other
                    exceptions based on applicable laws.
                    <br>
                    <br>
                    In all other instances of disclosure of personal data to third parties with your express consent, we
                    will endeavor to provide adequate supervision over the handling and administration of your personal
                    data
                    by such third parties, as well as to provide for adequate forms of protection over such personal
                    data.
                    <br>
                    <br>
                    Where personal data is transferred by us to any third parties outside of the country in which you
                    live
                    or of which you are a passport holder, we will ensure that such transfers are compliant with the
                    requirements under applicable laws. In this regard, we will take necessary measures to ensure that
                    such
                    overseas recipients are bound by legally enforceable obligations to ensure that these overseas
                    recipients provide a standard of protection to the personal data so transferred that is comparable
                    to
                    the protection under the personal data protection laws of the country which we transfer the personal
                    data out from.
                    <br>
                    <br>
                    <b style="color: #012b43;">5.Request for access and/or correction of personal data</b>
                    <br>
                    <br>
                    Under applicable law, you have among others, the rights (under the conditions set out in applicable
                    law)
                    to check whether and what kind of Personal Data we hold about you and to request copies of such data
                    to
                    request correction, supplementation or deletion of your Personal Data that is inaccurate or
                    processed in
                    non-compliance with applicable requirements to request us to restrict the processing of your
                    Personal
                    Data in certain circumstances, to object for legitimate reasons to the processing of your Personal
                    Data
                    or to revoke consent previously granted for processing to request data portability to know the
                    identities of third parties to which your Personal Data are transferred and to lodge a complaint
                    with
                    the competent authority.
                    <br>
                    <br>
                    You may request to access and/or correct your personal data currently in our possession or under our
                    control at any time by submitting your request to the contact details listed below at section 9.
                    <br>
                    <br>
                    <b style="color: #012b43;">6.Request to withdraw consent</b>
                    <br>
                    <br>
                    You may withdraw your consent for the collection, use and/or disclosure of your personal data in our
                    possession or under our control at any time by submitting your request to the contact details listed
                    below.
                    <br>
                    <br>
                    We will process your request within a reasonable time from such a request for withdrawal of consent
                    being made, and will thereafter refrain from collecting, using and/or disclosing your personal data
                    in
                    the manner stated in your request.
                    <br>
                    <br>
                    <b style="color: #012b43;">7.Security</b>
                    <br>
                    <br>
                    The security of your Personal Data is important to us but remember that no method of transmission
                    over
                    the Internet, or method of electronic storage, is 100% secure. While we strive to use commercially
                    acceptable means to protect your Personal Data, we cannot guarantee its absolute security.
                    <br>
                    <br>
                    <b style="color: #012b43;">8.Administration and management of personal data</b>
                    <br>
                    <br>
                    We will take appropriate measures to keep your personal data accurate, complete and updated.
                    <br>
                    <br>
                    We will also take commercially reasonable efforts to take appropriate precautions and preventive
                    measures to ensure that your personal data is adequately protected and secured. Appropriate security
                    arrangements will be taken to prevent any unauthorized access, collection, use, disclosure, copying,
                    modification, leakage, loss, damage and/or alteration of your personal data. However, we cannot
                    assume
                    responsibility for any unauthorized use of your personal data by third parties which are wholly
                    attributable to factors beyond our control.
                    <br>
                    <br>

                    We will also take commercially reasonable efforts to ensure that the personal data in our possession
                    or
                    under our control is destroyed and/or anonymised as soon as it is reasonable to assume that (i) the
                    purpose for which that personal data was collected is no longer being served by the retention of
                    such
                    personal data; and (ii) retention is no longer necessary for any other legal or business purposes.
                    <br>
                    <br>
                    We will, in any case, retain your Personal Data for as long as there are statutory retention
                    obligations
                    or potential legal claims that are not yet time-barred.
                    <br>
                    <br>
                    <b style="color: #012b43;">9.Complaint Process</b>

                    <br>
                    <br>
                    If you have any complaint or grievance regarding about how we are handling your personal data, we
                    welcome you to contact us with your complaint or grievance.
                    <br>
                    <br>
                    Please contact us through one of the following methods with your complaint or grievance.
                    <br>
                    <br>
                    Email address: <a href="mailto:support@centuriongm.com">support@centuriongm.com</a>
                    (Attention to: Data Protection Officer)
                    <br>
                    <br>
                    Your indication at the subject head that it is a Personal Data complaint would assist us in
                    attending to
                    your complaint speedily by passing it on to the relevant staff. For example, you could title the
                    subject
                    header as “Personal Data Complaint”.
                    <br>
                    <br>
                    We will certainly strive to deal with any complaint or grievance that you may have speedily and
                    fairly.
                    <br>
                    <br>
                    <b style="color: #012b43;">10.Updates on Privacy Policy</b>
                    <br>
                    <br>
                    This Privacy Policy is effective as of the date shown above and will remain in effect except with
                    respect to any changes in its provisions in the future, which will be in effect immediately after
                    being
                    posted on this page.
                    <br>
                    <br>
                    We reserve the right to update or change our Privacy Policy at any time and you should check this
                    Privacy Policy periodically. Any modified Privacy Policy will be posted on this page.
                    <br>
                    <br>
                    <b style="color: #012b43;">11.Statement concerning the use of cookies</b>
                    <br>
                    <br>
                    Cookies are files with small amount of data, which may include an anonymous unique identifier and
                    are
                    sent to your browser from a web site and stored on your computer’s hard drive.
                    <br>
                    <br>
                    Like many sites, we use cookies to collect information. You can instruct your browser to refuse all
                    cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may
                    not
                    be able to use some portions of the Site.
                    <br>
                    <br>
                    Some cookies used on this website collect information about how visitors use a website, for instance
                    which pages visitors go to most often, and if they get error messages from web pages. These cookies
                    don’t collect information that identifies a visitor. All information these cookies collect is
                    aggregated
                    and therefore anonymous. It is only used to improve how our website works.
                    <br>
                    <br>
                    Some cookies used on this website allow the website to remember choices you make (such as your user
                    name, language or the region you are in) and provide enhanced, more personal features. These cookies
                    can
                    also be used to remember changes you have made to text size, fonts and other parts of web pages that
                    you
                    can customise. They may also be used to provide services you have asked for such as watching a video
                    or
                    commenting or providing feedback. The information these cookies collect may be anonymised and they
                    cannot track your browsing activity on other websites. Cookies may also be used to improve the user
                    experience and to enable some of the functionality provided by this website
                    <br>
                    <br>
                    Please note that some cookies may be placed by third party service providers who perform some of
                    these
                    functions (or other services) for us. Some of these services may be used to track your behavior on
                    other
                    websites and we have no control over this.
                    <br>
                    <br>
                    By continuing to use this website without adjusting your browser’s cookie settings, you agree that
                    we
                    can place these cookies on your device.
                </h6>
            </div>
        </div>
    </div>
</div>